<div class="form-horizontal">
  <div [formGroup]="experimentDesignFormGroup">
    <accordion>

      <accordion-group heading="Design Attributes" [isOpen]="true">
        <div class="form-group" [class.has-error]="control('numberOfTreatments').invalid">
          <label class="control-label col-sm-2">
            Treatments
            <a tooltip="The number of specific related experimental conditions to be tested (example: nitrogen rates, irrigation protocols, etc.)"
               placement="right"
               container="body">
              <span class="glyphicon glyphicon-info-sign"></span>
            </a>
          </label>
          <span class="col-sm-10">

            <app-treatment-count-input formControlName="numberOfTreatments"></app-treatment-count-input>

            <div class="alert alert-danger"
                 *ngIf="control('numberOfTreatments').errors?.min">
              Number of Treatments must be at least {{ control('numberOfTreatments').errors?.min.min }}.
            </div>
          </span>
        </div>

        <div class="form-group" [class.has-error]="control('numberOfReps').invalid">
          <label class="control-label col-sm-2">
            Replicates
            <a tooltip="The number of individual plants or groups of plants of a single genetic identity representing a single treatment on a single planting date"
               placement="right"
               container="body">
              <span class="glyphicon glyphicon-info-sign"></span>
            </a>
          </label>
          <span class="col-sm-10">

            <input type="number" class="form-control" formControlName="numberOfReps" appIntegerValueAccessor />

            <div class="alert alert-danger"
                 *ngIf="control('numberOfReps').errors?.min">
              Number of Replicates must be at least {{ control('numberOfReps').errors?.min.min }}.
            </div>
          </span>
        </div>

        <div class="form-group">
          <label class="col-sm-2 control-label">
            Indexing
            <a tooltip="Does this experiment have design parameters requiring the plants to arrange in a specific orientation?"
               placement="right"
               container="body">
              <span class="glyphicon glyphicon-info-sign"></span>
            </a>
          </label>
          <span class="col-sm-10">
            <ui-switch formControlName="indexing" checkedLabel="Yes" uncheckedLabel="No"></ui-switch>
          </span>
        </div>

        <div *ngIf="isWheatRequest" class="form-group" [class.has-error]="control('numberOfSeedsPerCell').invalid">
          <label class="control-label col-sm-2"> Seeds per Cell </label>
          <span class="col-sm-10">
            <input type="number" class="form-control" formControlName="numberOfSeedsPerCell" appIntegerValueAccessor min="1" max="3" />

            <div class="alert alert-danger"
                 *ngIf="control('numberOfSeedsPerCell').errors">
              Number of Seeds per Cell must be between 1 - 3.
            </div>
          </span>
        </div>
      </accordion-group>

      <accordion-group heading="Seed Needs" [isOpen]="true">
        <div class="form-group">
          <app-seed-needs-upload [experimentDesignFormGroup]="experimentDesignFormGroup"
                                 [crop]="requestDetails.crop"
                                 [treatmentCount]="control('numberOfTreatments').value">
          </app-seed-needs-upload>
        </div>
      </accordion-group>

      <accordion-group heading="Seed Request" [isOpen]="true">
        <app-seed-requests [experimentDesignFormGroup]="experimentDesignFormGroup"></app-seed-requests>
      </accordion-group>

      <accordion-group heading="Recurrence" [isOpen]="true">
        <app-recurrence [experimentDesignFormGroup]="experimentDesignFormGroup" [plantingDate]="requestDetails.plantingDate"></app-recurrence>
      </accordion-group>

      <accordion-group heading="Planting Instructions" [isOpen]="true">
        <app-planting-instructions [experimentDesignFormGroup]="experimentDesignFormGroup" [isWheatRequest]="isWheatRequest"></app-planting-instructions>
      </accordion-group>



      <accordion-group heading="Flat Seeding/Transplanting Instructions" [isOpen]="true">
        <app-flat-instructions [ceRequestOptions]="ceRequestOptions" [experimentDesignFormGroup]="experimentDesignFormGroup"></app-flat-instructions>
      </accordion-group>

      <accordion-group *ngIf="pottingInstructionsEnabled" heading="Pot Seeding/Transplanting Instructions" [isOpen]="true">
        <app-potting-instructions [ceRequestOptions]="ceRequestOptions" [experimentDesignFormGroup]="experimentDesignFormGroup"></app-potting-instructions>
      </accordion-group>

      <accordion-group *ngIf="pollinationInstructionsEnabled" heading="Pollination Instructions" [isOpen]="true">
        <app-pollination-instructions [experimentDesignFormGroup]="experimentDesignFormGroup"
                                      [crop]="requestDetails.crop">
        </app-pollination-instructions>
      </accordion-group>

      <accordion-group heading="Plant Handling Instructions" [isOpen]="true">
        <app-plant-handling-instructions [experimentDesignFormGroup]="experimentDesignFormGroup" [ceRequestOptions]="ceRequestOptions"></app-plant-handling-instructions>
      </accordion-group>

      <accordion-group heading="Spray Booth Study Instructions" [isOpen]="true">
        <app-spray-booth-study [ceRequestOptions]="ceRequestOptions" [experimentDesignFormGroup]="experimentDesignFormGroup"></app-spray-booth-study>
      </accordion-group>

      <accordion-group *ngIf="harvestInstructionsEnabled" heading="Harvest Instructions" [isOpen]="true">
        <app-harvest-instructions [ceRequestOptions]="ceRequestOptions" [harvestInstructions]="control('harvestInstructions')"></app-harvest-instructions>
      </accordion-group>

      <accordion-group heading="Sampling Needs" [isOpen]="true">
        <app-sampling-needs [requestDetails]="requestDetails" [experimentDesignFormGroup]="experimentDesignFormGroup" [ceRequestOptions]="ceRequestOptions"></app-sampling-needs>
      </accordion-group>

    </accordion>
  </div>
</div>



// WEBPACK FOOTER //
// F:/PHAZP5152IS01-2/_work/98/s/src/app/request-creation/experiment-design/experiment-design-form/experiment-design-form.component.html